module.exports = "/_next/static/images/motive-bg-mobile-f6e78078c0c2de7c59343dd8b7b23d0a.svg";